import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content">
        <p className="footer__content-text">Webdesign by Stian Martinsen-Stormyr</p>
      </div>
      <div className="footer__content">
        <p className="footer__content-text">©2023</p>
      </div>
    </footer>
  );
}

export default Footer;
